// extracted by mini-css-extract-plugin
export var externalLink = "_ac-0";
export var internalLinkLabel = "_ac-1";